var map = {
	"./goal.jpg": "a614",
	"./logo.png": "cf05",
	"./nutrition.jpg": "fdf3",
	"./train.png": "358c",
	"./train2.png": "c986",
	"./train3.webp": "24e7",
	"./train4.jpg": "73af",
	"./vid.mp4": "6758",
	"./weights.jpg": "a43c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";